import { Button, Col, Form, Input, Row, Space } from "antd";
import useAjax from "helpers/ajax";
import { showError, showMessage } from "helpers/utility";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
  const navigate = useNavigate();
  const { put } = useAjax();
  const onFinish = (values) => {
    put("api/v1/users/changepassword", { ...values })
      .then((resp) => {
        showMessage(resp.success, resp.message);
      })
      .catch((err) => {
        showError(err);
      });
  };

  return (
    <Form layout="vertical" onFinish={onFinish}>
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item
            label="Old password"
            name="oldPassword"
            rules={[{ required: true }]}
          >
            <Input.Password autoFocus />
          </Form.Item>
          <Form.Item
            label="New password"
            name="password"
            rules={[{ required: true }, { min: 5 }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="Confirm password"
            name="confirmPassword"
            dependencies={["password"]}
            rules={[
              { required: true },
              { min: 5 },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Password doesn't match."));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                Save
              </Button>
              <Button
                htmlType="button"
                onClick={() => {
                  navigate("/");
                }}
              >
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
export default ChangePassword;
